import type { Locale } from "date-fns";
import { ar } from "date-fns/locale";

/**
 * Arabic for react-datepicker. Its weekday header uses date-fns' "short" day
 * name, which in Arabic is the whole word ("خميس", "أربعاء") — seven of them
 * don't fit a phone and run together ("خميسجمعة"). Headers use the one-letter
 * form instead: ح ن ث ر خ ج س.
 */
export const arCalendar: Locale = {
  ...ar,
  localize: {
    ...ar.localize,
    day: (day, options) => ar.localize.day(day, options?.width === "short" ? { ...options, width: "narrow" } : options),
  },
};
